import { 
  CUIDAR_OMINT_PLAN_GROUP_CODE, 
  OMINT_PLAN_GROUP_CODE, 
  SAMI_PLAN_GROUP_CODE 
} from 'settings/_planGroupCode'

const SCHEDULE_TOKEN_GROUPED_PLANS_ENABLED = [
  CUIDAR_OMINT_PLAN_GROUP_CODE,
  OMINT_PLAN_GROUP_CODE,
  SAMI_PLAN_GROUP_CODE,
]

export const isScheduleTokenEnabled = (planGroupCode: string): boolean => {
  return SCHEDULE_TOKEN_GROUPED_PLANS_ENABLED.includes(planGroupCode)
}

export const planGroupsEnabledScheduleToken = {
  CUIDAR_OMINT_PLAN_GROUP_CODE,
  OMINT_PLAN_GROUP_CODE,
  SAMI_PLAN_GROUP_CODE,
}
